import React from 'react'

import { getClassesFromMarginsProp } from '../../utils/utils'

import './text.styles.scss'

const Text = ({
  content,
  classNames,
  margins,
  clickHandler,
  ...otherProps
}) => {
  if (typeof classNames === 'undefined') classNames = ''
  const marginClasses = getClassesFromMarginsProp(margins)

  return (
    <p className={`${classNames} ${marginClasses}`} onClick={clickHandler}>
      {content}
    </p>
  )
}

export default Text
